var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "benefits",
      staticClass: "benefits",
      attrs: { "data-hover": "white" }
    },
    [
      _c(
        "v-row",
        { staticClass: "benefits__row", attrs: { variant: "flex" } },
        [
          _c(
            "v-column",
            { staticClass: "benefits__list-wrapper", attrs: { large: 12 } },
            [
              _c(
                "ul",
                { staticClass: "benefits__list" },
                _vm._l(_vm.benefits, function(item) {
                  return _c(
                    "li",
                    {
                      key: "benefits__item-" + item.id,
                      ref: "benefitItem",
                      refInFor: true,
                      staticClass: "benefits__item"
                    },
                    [
                      _c("v-typo", {
                        staticClass: "benefits__headline",
                        attrs: { variant: "h2" },
                        domProps: { innerHTML: _vm._s(item.title) }
                      }),
                      _vm._v(" "),
                      _c("v-image", {
                        staticClass: "benefits__image",
                        attrs: {
                          alt: item.alt,
                          "aspect-ratio": 1,
                          tiny: _vm.getGift(item)
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("v-icon", {
                staticClass: "benefits__icon",
                attrs: { name: "symbols/letters/a-white" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }